import { apiClient } from '@/lib/api/api-client';

const BASE = '/api/freight-locations';

export type FreightLocationType =
  | 'AIRPORT'
  | 'SEAPORT'
  | 'INLAND_TERMINAL'
  | 'WAREHOUSE'
  | 'CUSTOMS'
  | 'OTHER';

export const FREIGHT_LOCATION_TYPE_LABELS: Record<FreightLocationType, string> = {
  AIRPORT: 'Aeropuerto',
  SEAPORT: 'Puerto marítimo',
  INLAND_TERMINAL: 'Terminal interior',
  WAREHOUSE: 'Almacén',
  CUSTOMS: 'Aduana',
  OTHER: 'Otro',
};

export interface FreightLocation {
  id: string;
  tenantId: string;
  code: string;
  name: string;
  type: FreightLocationType;
  // Dirección
  address: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  countryCode: string | null;
  latitude: number | string | null;
  longitude: number | string | null;
  timeZone: string | null;
  // Contacto
  phone: string | null;
  email: string | null;
  website: string | null;
  contactName: string | null;
  // Códigos operativos
  iataCode: string | null;
  unLocode: string | null;
  notes: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateFreightLocationDto {
  /** Opcional: si no se manda, el backend lo genera automáticamente del nombre/ciudad */
  code?: string;
  name: string;
  type?: FreightLocationType;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  countryCode?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  timeZone?: string | null;
  phone?: string | null;
  email?: string | null;
  website?: string | null;
  contactName?: string | null;
  iataCode?: string | null;
  unLocode?: string | null;
  notes?: string | null;
  isActive?: boolean;
}

export type UpdateFreightLocationDto = Partial<CreateFreightLocationDto>;

export const freightLocationsService = {
  list: (filter?: { type?: FreightLocationType; q?: string; isActive?: boolean }) => {
    const qs = new URLSearchParams();
    if (filter?.type) qs.set('type', filter.type);
    if (filter?.q) qs.set('q', filter.q);
    if (filter?.isActive !== undefined) qs.set('isActive', String(filter.isActive));
    const tail = qs.toString() ? `?${qs.toString()}` : '';
    return apiClient.get<FreightLocation[]>(`${BASE}${tail}`);
  },
  get: (id: string) => apiClient.get<FreightLocation>(`${BASE}/${id}`),
  create: (dto: CreateFreightLocationDto) => apiClient.post<FreightLocation>(BASE, dto),
  update: (id: string, dto: UpdateFreightLocationDto) =>
    apiClient.patch<FreightLocation>(`${BASE}/${id}`, dto),
  remove: (id: string) => apiClient.delete<void>(`${BASE}/${id}`),
};
